import React, { useState, useEffect, useContext} from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import AOS from "aos";
import "aos/dist/aos.css";
import Web3 from "web3";
import Context from "../../../context/context";
import UFO from '../abi/Ufo.json';
import { sendGetRequest,providerURL } from '../../../helper/Helper'; 

const StatBox = ({ title = "Price", value = 0, delay = 0, duration = 0}) => {
  const { ref, inView } = useInView({ triggerOnce: true });
  const decimals = title === "Price" ? 8 : 2;
  
  return (
    <div className="col-lg-4">
      <div className="snState relative value mt-3" data-aos="fade-up" data-aos-delay={delay} data-aos-duration={duration} ref={ref} >
        <div className="d-flex justify-content-between">
          <div className="perVal fInter d-flex align-items-center">
            <span>{title}</span>
          </div>
        </div>
        <div>
          <h3 className="dollorValue value">
            {
              title !=="Holders" && title !=="Stakers" ?
              <>
                <span className="dollor">$</span>
              </>
              :
              <>
              </> 
            }
            {inView && <CountUp end={value} duration={2} separator="," decimals={decimals}/>}
          </h3>
        </div>
      </div>
    </div>
  );
};

const LiveStates = () => {
  const {ufoPrice} = useContext(Context);
  const [marketCap, setMarketCap] = useState(0);
  const [burnValue, setBurnValue] = useState(0);
  const [liqudityValue, setLiqudityValue] = useState(0);
  const [holdValue, setHoldValue] = useState(0);

  useEffect(() => {
    AOS.init({
      once: true
    });
    getData();
  }, [ufoPrice]);

  const stats = [
    { title: "Price", value: ufoPrice, delay: 200},
    { title: "Market Cap", value: marketCap, delay: 200},
    { title: "Burned Value", value: burnValue, delay: 200},
    { title: "Liqudity Value", value: liqudityValue, delay: 200},
    { title: "Hold Value", value: holdValue, delay: 200}
  ];

  const getData = async () => {
    const web3 = new Web3(providerURL());
    const UFOContract = new web3.eth.Contract(UFO.ABI, UFO.Contract);

    let totalSupply = parseFloat(parseInt(await UFOContract.methods.totalSupply().call()) / 10 ** 18).toFixed(2);
    let burnSupply = parseFloat(parseInt(await UFOContract.methods.balanceOf("0x0000000000000000000000000000000000000369").call()) / 10 ** 18).toFixed(2);
    let liquidityData = await getLiquidityData();

    setMarketCap(ufoPrice * (parseFloat(totalSupply) - parseFloat(burnSupply)));
    setBurnValue(ufoPrice * burnSupply);
    setLiqudityValue(liquidityData.USDLiquidity);
    setHoldValue(ufoPrice * (parseFloat(totalSupply) - (parseFloat(burnSupply) + parseFloat(liquidityData.UFOLiquidity))));
  }

  const getLiquidityData = async () => {
      try {
        const response = await sendGetRequest('ufo/pairs-volumes/latest/all');
        if (response && response.status === 200) {
          let UFOLiquidity = 0;
          let USDLiquidity = 0;
          response.data.forEach(pair => {
            if (pair.pair_ufo.base_symbol === "UFO") 
            {
              UFOLiquidity += pair.base_liquidity;
              USDLiquidity += pair.liquidity;
            } 
            else if (pair.pair_ufo.qoute_symbol === "UFO") 
            {
              UFOLiquidity += pair.quote_liquidity;
              USDLiquidity += pair.liquidity;
            }
          });
         return { UFOLiquidity, USDLiquidity };
        }
      } catch (error) {}
    }

  return (
    <section className="liveStats padsec UFOSEC">
      <div className="container">
        <div className="liveStatsIn">
          <div className="d-flex align-items-center justify-content-between gap-1 flex-wrap">
            <h2>UFO INFO</h2>
          </div>
          <div className="statsMulti">
            <div className="row">
              {stats.map((stat, idx) => (
                <StatBox
                  key={idx}
                  title={stat.title}
                  value={stat.value}
                  delay={stat.delay}
                  duration={200 + idx * 100}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LiveStates;
